/*******************************************************************************
Chemical Actions: All interactions in the chemical component

*******************************************************************************/
import { FETCH_FIELDS, FETCH_MANAGERS, FETCH_CULT_EMPLOYEES, FETCH_CERTIFICATION,
  CLEAR_FORM } from './types';
import { ROOT_URL } from '../../constants';
import { error } from './chem_actions';
import axios from 'axios';
/**
* fetchFields(): Fetches fields based on selected location
* @param {String} loc: Location(71,72)
* @returns {Array} All fields based on location
* @called-in: ['/components/reports/reports.js->report_form.js']
* @notes: Added setTimeout as the location dropdown would reset on async fetch; possible rerender
**/
export function fetchFields(loc) {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchFields`, {
      params: { loc },
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        dispatch({ type: FETCH_FIELDS, payload: res.data.fields });
      }).catch((err) => dispatch(error(`There was an error fetching fields by location`)));
  }
}

/**
* fetchManagers(): Fetches all cultivation managers
* @returns {Array} managers
* @called-in: ['/components/documentation/introduction.js']
**/
export function fetchManagers() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchManagers`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        dispatch({ type: FETCH_MANAGERS, payload: res.data.managers });
      }).catch((err) => dispatch(error(`There was an error fetching managers.`)));
  }
}
/**
* fetchEmployees(): Fetches employees
* @returns {Array} employees
* @called-in: ['/components/chem_app/chem_app_create.js']
**/
export function fetchEmployees() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchEmployees`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        dispatch({ type: FETCH_CULT_EMPLOYEES, payload: res.data.employees });
      }).catch((err) => dispatch(error(`There was an error fetching employees. ${err}`)));
  }
}
/**
* fetchCertification(): Fetches employees
* @returns {Array} employees
* @called-in: ['/components/chem_app/chem_app_create.js']
**/
export function fetchCertification() {
  return (dispatch) => {
    axios.get(`${ROOT_URL}/fetchCertification`, {
      headers: { authorization: localStorage.getItem('token') }
    }).then((res) => {
        dispatch({ type: FETCH_CERTIFICATION, payload: res.data.cert });
      }).catch((err) => dispatch(error(`There was an error fetching employees. ${err}`)));
  }
}
/**
* clearForm(): Clears a form
* @param {String} formId: form id to clear
* @called-in: ['/components/chem_app/chem_app_create.js; fertilizer/fertilizer_create.js']
**/
export function clearForm(formId) {
  if (document.getElementById(formId) === null || document.getElementById(formId) === undefined || document.getElementById(formId) === '') return { type: CLEAR_FORM };
  document.getElementById(formId).reset();
  return {
    type: CLEAR_FORM
  }
}




/* END */



// WEBPACK FOOTER //
// ./src/cultivation/actions/utils_actions.js